"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { ShowChart } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { getProfileUrlByIdentifier } from "@/components/profile/utils";
import { useAddress } from "@/hooks/wallet";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuPortfolioItem(t0) {
  const $ = _c(19);
  let isSheet;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = onClick;
    $[3] = rest;
  } else {
    isSheet = $[1];
    onClick = $[2];
    rest = $[3];
  }
  const address = useAddress();
  const t = useTranslations("MoreMenuPortfolioItem");
  const t1 = `${getProfileUrlByIdentifier(address)}/portfolio`;
  let t2;
  if ($[4] !== isSheet) {
    t2 = isSheet ? <Button icon={ShowChart} size="lg" variant="secondary" /> : <MoreMenuItemAvatar icon={ShowChart} />;
    $[4] = isSheet;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("title");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <MoreMenuItemContent><MoreMenuItemTitle>{t3}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isSheet || $[11] !== rest || $[12] !== t2 || $[13] !== t4) {
    t5 = <MoreMenuItem isSheet={isSheet} {...rest}>{t2}{t4}</MoreMenuItem>;
    $[10] = isSheet;
    $[11] = rest;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== onClick || $[16] !== t1 || $[17] !== t5) {
    t6 = <Link href={t1} onClick={onClick} variant="unstyled">{t5}</Link>;
    $[15] = onClick;
    $[16] = t1;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}